import {
  GET_LIST_PACKAGE_REQUEST,
  GET_LIST_PACKAGE_SUCCESS,
  GET_LIST_PACKAGE_FAIL,
  DELETE_LIST_PACKAGE_REQUEST,
  DELETE_LIST_PACKAGE_SUCCESS,
  DELETE_LIST_PACKAGE_FAIL,
  DUPLICATE_LIST_PACKAGE_REQUEST,
  DUPLICATE_LIST_PACKAGE_SUCCESS,
  DUPLICATE_LIST_PACKAGE_FAIL,
  CREATE_PACKAGE_REQUEST,
  CREATE_PACKAGE_SUCCESS,
  CREATE_PACKAGE_FAIL,
  UPDATE_PACKAGE_REQUEST,
  UPDATE_PACKAGE_SUCCESS,
  UPDATE_PACKAGE_FAIL,
  GET_PACKAGE_REQUEST,
  GET_PACKAGE_SUCCESS,
  GET_PACKAGE_FAIL,
  GET_LIST_PACKAGE_SERVICE_REQUEST,
  GET_LIST_PACKAGE_SERVICE_SUCCESS,
  GET_LIST_PACKAGE_SERVICE_FAIL,
  GET_LIST_PACKAGE_SERVICE_ITEM_REQUEST,
  GET_LIST_PACKAGE_SERVICE_ITEM_SUCCESS,
  GET_LIST_PACKAGE_SERVICE_ITEM_FAIL,
  ADD_LIST_PACKAGE_SERVICE_REQUEST,
  ADD_LIST_PACKAGE_SERVICE_SUCCESS,
  ADD_LIST_PACKAGE_SERVICE_FAIL,
  DELETE_LIST_PACKAGE_SERVICE_REQUEST,
  DELETE_LIST_PACKAGE_SERVICE_SUCCESS,
  DELETE_LIST_PACKAGE_SERVICE_FAIL,
  LIST_PACKAGE_ADDITIONAL_INFO_REQUEST,
  LIST_PACKAGE_ADDITIONAL_INFO_SUCCESS,
  LIST_PACKAGE_ADDITIONAL_INFO_FAIL,
  LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_REQUEST,
  LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_SUCCESS,
  LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_FAIL,
  ADD_PACKAGE_ADDITIONAL_INFO_REQUEST,
  ADD_PACKAGE_ADDITIONAL_INFO_SUCCESS,
  ADD_PACKAGE_ADDITIONAL_INFO_FAIL,
  DELETE_PACKAGE_ADDITIONAL_INFO_REQUEST,
  DELETE_PACKAGE_ADDITIONAL_INFO_SUCCESS,
  DELETE_PACKAGE_ADDITIONAL_INFO_FAIL,
  GET_LIST_PACKAGE_SERVICE_SUMMARY_REQUEST,
  GET_LIST_PACKAGE_SERVICE_SUMMARY_SUCCESS,
  GET_LIST_PACKAGE_SERVICE_SUMMARY_FAIL,
  RESET_PACKAGE_ADDITIONAL_INFO_AND_MEDICAL_INFO,
  UPDATE_PACKAGE_PROPERTIES_FORMAT_OPTION_REQUEST,
  UPDATE_PACKAGE_PROPERTIES_FORMAT_OPTION_SUCCESS,
  UPDATE_PACKAGE_PROPERTIES_FORMAT_OPTION_FAIL
} from '../../constants/packages'

const initialState = {
  loadingDeleteAdditionalInfoAndMedicalInfo: false,
  loadingAddAdditionalInfoAndMedicalInfo: false,
  loadingListAdditionalAndMedicalInfoInfo: false,
  packageAdditionalInfoAndMedicalInfoList: [],
  loadingAddPackageService: false,
  packageServiceSummaries: [],
  loadingPackage: false,
  loadingPatchDelete: false,
  loadingDetailPackage: false,
  loadingPackageService: false,
  loadingPackageServiceItem: false,
  loadingDeletePackageService: false,
  packageServices: [],
  packageServiceItems: [],
  packageList: [],
  packageServiceAdditionalInfoList: [],
  packageItem: {},
  error: null,
  pageable: {
    page: 1,
    size: 10,
    hits: 1
  }
}

const packageServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_PACKAGE_REQUEST:
      return { ...state, loadingPackage: true }
    case GET_LIST_PACKAGE_SUCCESS:
      return {
        ...state,
        loadingPackage: false,
        packageList: action.payload,
        pageable: action.pageable
      }
    case GET_LIST_PACKAGE_FAIL:
      return {
        ...state,
        loadingPackage: false,
        error: action.payload,
        packageList: [],
        pageable: {
          page: 1,
          size: 10
        }
      }
    case DELETE_LIST_PACKAGE_REQUEST:
      return { ...state, loadingPatchDelete: true }
    case DELETE_LIST_PACKAGE_SUCCESS:
      return { ...state, loadingPatchDelete: false }
    case DELETE_LIST_PACKAGE_FAIL:
      return { ...state, loadingPatchDelete: false, error: action.payload }
    case DUPLICATE_LIST_PACKAGE_REQUEST:
      return { ...state, loadingPatchDelete: true }
    case DUPLICATE_LIST_PACKAGE_SUCCESS:
      return { ...state, loadingPatchDelete: false }
    case DUPLICATE_LIST_PACKAGE_FAIL:
      return { ...state, loadingPatchDelete: false, error: action.payload }
    case CREATE_PACKAGE_REQUEST:
      return { ...state, loadingPatchDelete: true }
    case CREATE_PACKAGE_SUCCESS:
      return { ...state, loadingPatchDelete: false }
    case CREATE_PACKAGE_FAIL:
      return { ...state, loadingPatchDelete: false, error: action.payload }
    case UPDATE_PACKAGE_REQUEST:
      return { ...state, loadingPatchDelete: true }
    case UPDATE_PACKAGE_SUCCESS:
      return { ...state, loadingPatchDelete: false }
    case UPDATE_PACKAGE_FAIL:
      return { ...state, loadingPatchDelete: false, error: action.payload }
    case GET_PACKAGE_REQUEST:
      return { ...state, loadingDetailPackage: true }
    case GET_PACKAGE_SUCCESS:
      return {
        ...state,
        loadingDetailPackage: false,
        packageItem: action.payload
      }
    case GET_PACKAGE_FAIL:
      return { ...state, loadingDetailPackage: false, error: action.payload }
    case GET_LIST_PACKAGE_SERVICE_REQUEST:
      return { ...state, loadingPackageService: true }
    case GET_LIST_PACKAGE_SERVICE_SUCCESS:
      return {
        ...state,
        loadingPackageService: false,
        packageServices: action.payload,
        pageable: action.pageable
      }
    case GET_LIST_PACKAGE_SERVICE_FAIL:
      return {
        ...state,
        loadingPackageService: false,
        error: action.payload,
        packageServices: action?.dummy,
        pageable: {
          page: 1,
          size: 10
        }
      }
    case GET_LIST_PACKAGE_SERVICE_ITEM_REQUEST:
      return {
        ...state,
        loadingPackageServiceItem: true
      }
    case GET_LIST_PACKAGE_SERVICE_ITEM_SUCCESS: {
      return {
        ...state,
        loadingPackageServiceItem: false,
        packageServiceItems: action.payload,
        error: null
      }
    }
    case GET_LIST_PACKAGE_SERVICE_ITEM_FAIL:
      return {
        loadingPackageServiceItem: false,
        packageServiceItems: action?.dummy,
        error: action.payload
      }
    case ADD_LIST_PACKAGE_SERVICE_REQUEST:
      return { ...state, loadingAddPackageService: true }
    case ADD_LIST_PACKAGE_SERVICE_SUCCESS:
      return {
        ...state,
        loadingAddPackageService: false,
        error: null
      }
    case ADD_LIST_PACKAGE_SERVICE_FAIL:
      return {
        ...state,
        loadingAddPackageService: false,
        error: action.payload
      }
    case DELETE_LIST_PACKAGE_SERVICE_REQUEST:
      return { ...state, loadingDeletePackageService: true }
    case DELETE_LIST_PACKAGE_SERVICE_SUCCESS:
      return { ...state, loadingDeletePackageService: false }
    case DELETE_LIST_PACKAGE_SERVICE_FAIL:
      return { ...state, loadingDeletePackageService: false, error: action.payload }
    case LIST_PACKAGE_ADDITIONAL_INFO_REQUEST:
      return { ...state, loadingListAdditionalAndMedicalInfoInfo: true, packageAdditionalInfoAndMedicalInfoList: [] }
    case LIST_PACKAGE_ADDITIONAL_INFO_SUCCESS:
      const module = action?.module
      return {
        ...state,
        loadingListAdditionalAndMedicalInfoInfo: false,
        packageAdditionalInfoAndMedicalInfoList: module === 'format-option' ? [] : action.payload,
        packageFormatOptionList: module === 'format-option' ? action.payload : [],
        includeGeneralFormat: action.includeGeneralFormat || false,
        error: null
      }
    case LIST_PACKAGE_ADDITIONAL_INFO_FAIL:
      return {
        ...state,
        loadingListAdditionalAndMedicalInfoInfo: false,
        packageFormatOptionList: {},
        packageAdditionalInfoAndMedicalInfoList: action?.dummy || [],
        includeGeneralFormat: false,
        error: action.payload
      }
    case LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_REQUEST:
      return { ...state, loadingListServiceAdditionalInfoAndMedicalInfo: true, packageServiceAdditionalInfoAndMedicalInfoList: [] }
    case LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_SUCCESS:
      return {
        ...state,
        loadingListServiceAdditionalInfoAndMedicalInfo: false,
        packageServiceAdditionalInfoAndMedicalInfoList: action.payload,
        error: null
      }
    case LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_FAIL:
      return {
        ...state,
        loadingListServiceAdditionalInfoAndMedicalInfo: false,
        packageServiceAdditionalInfoAndMedicalInfoList: action?.dummy || [],
        error: action.payload
      }
    case ADD_PACKAGE_ADDITIONAL_INFO_REQUEST:
      return { ...state, loadingAddAdditionalInfoAndMedicalInfo: true }
    case ADD_PACKAGE_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        loadingAddAdditionalInfoAndMedicalInfo: false,
        packageAdditionalInfoAndMedicalInfoList: action.payload,
        error: null
      }
    case ADD_PACKAGE_ADDITIONAL_INFO_FAIL:
      return {
        ...state,
        loadingAddAdditionalInfoAndMedicalInfo: false,
        error: action.payload
      }
    case UPDATE_PACKAGE_PROPERTIES_FORMAT_OPTION_REQUEST:
      return { ...state, loadingAddAdditionalInfoAndMedicalInfo: true }
    case UPDATE_PACKAGE_PROPERTIES_FORMAT_OPTION_SUCCESS:
      return {
        ...state,
        loadingAddAdditionalInfoAndMedicalInfo: false,
        error: null
      }
    case UPDATE_PACKAGE_PROPERTIES_FORMAT_OPTION_FAIL:
      return {
        ...state,
        loadingAddAdditionalInfoAndMedicalInfo: false,
        error: action.payload
      }
    case DELETE_PACKAGE_ADDITIONAL_INFO_REQUEST:
      return { ...state, loadingDeleteAdditionalInfoAndMedicalInfo: true }
    case DELETE_PACKAGE_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        loadingDeleteAdditionalInfoAndMedicalInfo: false,
        packageAdditionalInfoAndMedicalInfoList: action.payload,
        error: null
      }
    case DELETE_PACKAGE_ADDITIONAL_INFO_FAIL:
      return {
        ...state,
        loadingDeleteAdditionalInfoAndMedicalInfo: false,
        error: action.payload
      }
    case GET_LIST_PACKAGE_SERVICE_SUMMARY_REQUEST:
      return {
        ...state,
        loadingPackageServiceSummary: true
      }
    case GET_LIST_PACKAGE_SERVICE_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingPackageServiceSummary: false,
        packageServiceSummaries: action.payload,
        error: null
      }
    case GET_LIST_PACKAGE_SERVICE_SUMMARY_FAIL:
      return {
        ...state,
        loadingPackageServiceSummary: false,
        error: action.payload,
        packageServiceSummaries: []
      }
    case RESET_PACKAGE_ADDITIONAL_INFO_AND_MEDICAL_INFO:
      return {
        ...state,
        packageAdditionalInfoAndMedicalInfoList: [],
        packageServiceAdditionalInfoAndMedicalInfoList: [],
        error: null
      }
    default:
      return state
  }
}

export default packageServiceReducer
